import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Sofia Lopez',
  image: 'https://cdn.magicpatterns.com/uploads/9Ja2c5JmxBTJ95rN1ABtcK/Testimonio_1.webp',
  country: 'México',
  flag: 'https://flagcdn.com/w80/mx.png'
}, {
  name: 'Monica Ospina',
  image: 'https://cdn.magicpatterns.com/uploads/kNw8tdkAZeSHGj144R7Liz/Testimonio_2.webp',
  country: 'Colombia',
  flag: 'https://flagcdn.com/w80/co.png'
}, {
  name: 'Ana Rodriguez',
  image: 'https://cdn.magicpatterns.com/uploads/rPdyKnqLSZhPv2J59hVHvu/Testimonio_3.webp',
  country: 'Perú',
  flag: 'https://flagcdn.com/w80/pe.png'
}, {
  name: 'Laura Jimenez',
  image: 'https://cdn.magicpatterns.com/uploads/sqLqt7PmSy26k1reQTgFyE/Testimonio_4.webp',
  country: 'Chile',
  flag: 'https://flagcdn.com/w80/cl.png'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream relative" data-id="element-327">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-328" />

      <div className="max-w-5xl mx-auto" data-id="element-329">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-330">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/10 text-caramel-dark font-medium text-sm mb-6 border border-caramel/20" data-id="element-331">
            <Star className="w-4 h-4 fill-caramel" data-id="element-332" />
            +1,200 alumnas felices
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-espresso leading-tight mb-4" data-id="element-333">
            Lo que dicen las repostera<span className="italic" data-id="element-334">s</span> que ya
            empezaron
          </h2>
          <p className="text-lg text-espresso-light max-w-2xl mx-auto" data-id="element-335">
            Historias reales de mujeres que transformaron su cocina en su primer
            negocio.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-id="element-336">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.1
        }} className="rounded-2xl overflow-hidden shadow-soft border border-caramel/10 bg-white" data-id="element-337">
              <img src={t.image} alt={`Testimonio de ${t.name}`} width={1080} height={1080} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-338" />
              <div className="flex items-center justify-center py-4" data-id="element-339">
                <img src={t.flag} alt={`Bandera de ${t.country}`} width={36} height={24} loading="lazy" decoding="async" className="h-6 w-auto rounded-[3px] shadow-sm border border-black/5" data-id="element-340" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}